<div class="" *ngIf="isUserLogin">
    <div class="main-contents" >
        <div class="dashborad padding-top-30">
            <div class="container">
                <dashboard-header></dashboard-header>                
                <div class="row">
                    <div class="col-lg-9 col-xs-9 col-md-9 col-sm-9 padding-bottom-15">
                        <h5 class="title">Add New {{itemType}}</h5>
                    </div>
                    <div class="col-lg-3 col-xs-3 col-md-3 col-sm-3 padding-bottom-15">
                        <button class="btn btn-outline-light btn-sm" (click)="goBack()">Go back</button>
                    </div>
                </div>
                <div class="row">
                    <form [formGroup]="addForm" novalidate action="" class="form">
                        <div class="col-lg-6 padding-bottom-15">
                            <div class="upload-wrapper">
                                <div class="row upload padding-bottom-15">
                                    <div class="col-lg-12">
                                        <label>Upload thumbnail image:</label>
                                    </div>
                                    <div class="col-lg-9">
                                        <input type="file" #thumbnailUploader thumbnail="true" name={{itemType}} (change)="onFileSelected($event)" />
                                    </div>
                                    <div class="col-lg-3">
                                        <button type="button" class="btn btn-outline-light btn-sm" (click)="onFileUpload()">Upload</button>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Thumbnail image:</label>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div *ngIf="thumbnailImage" class="image">
                                                <img  src="../../assets/images/{{itemType}}/thumbnail/{{thumbnailImage}}" />
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <input type="text" #thumbnailImageField formControlName="thumbnail_image" name="thumbnail_image" value={{thumbnailImage}} class="form-control" (change)="onThumbnailImageField($event)">
                                        </div>
                                    </div>
                                </div>                            
                                <div class="alert alert-danger" *ngIf="addForm.get('thumbnail_image').hasError('required') && addForm.get('thumbnail_image').touched">
                                    Please enter thumbnail image.
                                </div>
                            </div>
                            <div class="upload-wrapper">
                                <div class="row upload padding-bottom-15">
                                    <div class="col-lg-12">
                                        <label>Upload post images:</label>
                                    </div>
                                    <div class="col-lg-9">
                                        <input type="file" #postImageUploader thumbnail="false" name={{itemType}} (change)="onFileSelected($event)" />
                                    </div>
                                    <div class="col-lg-3">
                                        <button type="button" class="btn btn-outline-light btn-sm" (click)="onFileUpload()">Upload</button>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Post images:</label>
                                    <textarea type="textarea" formControlName="post_images" name="post_images" value={{postImagesField}} class="form-control" (change)="onPostImagesField($event)" ></textarea>
                                </div>
                                <div class="alert alert-danger" *ngIf="addForm.get('post_images').hasError('required') && addForm.get('post_images').touched">
                                    Please enter post images.
                                </div>
                                <div class="row" *ngIf="postImages">
                                    <div class="col-lg-4" *ngFor="let image of postImages">
                                        <div class="image">
                                            <img src="../../assets/images/{{itemType}}/{{image}}">
                                        </div>      
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 padding-bottom-15">
                            <div class="wrapper">
                                <div class="form-group d-none">
                                    <label>Id:</label>
                                    <input type="number" formControlName="id" name="id" class="form-control">
                                </div>
                                <div class="form-group d-none">
                                    <label>Id:</label>
                                    <input type="number" formControlName="id" name="id" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label>Title:</label>
                                    <input type="text" formControlName="title" name="title" class="form-control">
                                </div>
                                <div class="alert alert-danger" *ngIf="addForm.get('title').hasError('required') && addForm.get('title').touched">
                                    Please enter title.
                                </div>
                                <!-- <div class="alert alert-danger" *ngIf="addForm.get('title').hasError('maxlength') && addForm.get('title').touched">
                                    Maximum 12 characters are allowed.
                                </div> -->
                                <div class="form-group">
                                    <label>Meta keywords:</label>
                                    <textarea type="text" formControlName="meta_keywords" name="meta_keywords" class="form-control"></textarea>
                                </div>
                                <div class="form-group">
                                    <label>Meta description:</label>
                                    <textarea type="text" formControlName="meta_description" name="meta_description" class="form-control"></textarea>
                                </div>
                                <div class="form-group">
                                    <label>Post description:</label>
                                    <input type="textarea" formControlName="post_description" name="post_description" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label>Url:</label>
                                    <input type="text" formControlName="url" name="url" class="form-control">
                                </div>
                                <div class="alert alert-danger" *ngIf="addForm.get('url').hasError('required') && addForm.get('url').touched">
                                    Please enter url.
                                </div>
                                <div class="alert alert-danger" *ngIf="uniquePathCheck">
                                    Please use Unique path.
                                </div>
                                <div class="form-group">
                                    <label>Post category:</label>
                                    <!-- <input type="text" formControlName="post_category" name="post_category" class="form-control"> -->
                                    <select name="post_category" formControlName="post_category" name="post_category" class="form-control">
                                        <option value="">Select</option>
                                        <option *ngIf="itemType === 'photography'" value="Portarit">Portarit</option>
                                        <option *ngIf="itemType === 'photography'" value="Landscape">Landscape</option>
                                        <option *ngIf="itemType === 'photography'" value="Weddig">Wedding</option>
                                        <option *ngIf="itemType === 'photography'" value="Event">Event</option>
                                        <option *ngIf="itemType === 'photography'" value="Others">Others</option>
                                        <option *ngIf="itemType === 'websites'" value="WordPress">WordPress</option>
                                        <option *ngIf="itemType === 'websites'" value="Magento">Magento</option>
                                        <option *ngIf="itemType === 'websites'" value="drupal">Drupal</option>
                                        <option *ngIf="itemType === 'websites'" value="NetSuite">NetSuite</option>
                                        <option *ngIf="itemType === 'websites'" value=".Net">.Net</option>
                                    </select>
                                    
                                </div>
                                <div class="alert alert-danger" *ngIf="addForm.get('post_category').hasError('required') && addForm.get('post_category').touched">
                                    Please enter post category.
                                </div>
                                <div class="form-group">
                                    <label>Post type:</label>
                                    <!-- <input type="text" formControlName="post_type" name="post_type" class="form-control"> -->
                                    <select formControlName="post_type" name="post_type" class="form-control" >
                                        <option value="">Select</option>
                                        <option *ngIf="itemType === 'websites'" value="website">Website</option>
                                        <option *ngIf="itemType === 'photography'" value="photography">Photography</option>
                                    </select>
                                </div>
                                <div class="alert alert-danger" *ngIf="addForm.get('post_type').hasError('required') && addForm.get('post_type').touched">
                                    Please enter post type.
                                </div>
                                <div *ngIf="itemType === 'photography'" class="form-group">
                                    <label>Post location:</label>
                                    <input type="text" formControlName="post_location" name="post_location" (change)="onLocationChange($event)" class="form-control">
                                </div>
                                <div *ngIf="postLocation && center" class="location-map">
                                    <google-map
                                        height="300px"
                                        width="100%"
                                        [center]="center"
                                        [zoom]="zoom"
                                        [options]="mapOptions"
                                        (mapClick)="mapClicked($event)">
                                        <map-marker
                                            *ngFor="let m of markers; let i = index"
                                            #marker="mapMarker"
                                            [position]="m.position"
                                            [label]="m.label"
                                            [options]="{ draggable: m.draggable }"
                                            (mapClick)="clickedMarker(m.label, i, marker)"
                                            (mapDragend)="markerDragEnd(m, $event)">
                                        </map-marker>
                                        <map-info-window>
                                            <strong>{{ selectedMarkerLabel }}</strong>
                                        </map-info-window>
                                        <map-circle
                                            [center]="center"
                                            [radius]="circleOptions.radius"
                                            [options]="circleOptions">
                                        </map-circle>
                                    </google-map>
                                    <div class="speech-bubble-arrow"></div>
                                </div>
                                <div *ngIf="itemType === 'websites'" class="form-group">
                                    <label>Designer:</label>
                                    <input type="text" formControlName="designer" name="designer" class="form-control">
                                </div>                            
                                <div *ngIf="itemType === 'websites'" class="form-group">
                                    <label>Designer URL:</label>
                                    <input type="text" formControlName="designer_url" name="designer_url" class="form-control">
                                </div>                            
                                <div *ngIf="itemType === 'websites'" class="form-group">
                                    <label>eCommerce website:</label>
                                    <!-- <input type="text" formControlName="ecommerce_website" name="ecommerce_website" class="form-control"> -->
                                    <select formControlName="ecommerce_website" name="ecommerce_website" class="form-control" >
                                        <option value="">Select</option>
                                        <option value="true">True</option>
                                        <option value="false">False</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-lg-6"></div>
                                <div class="col-lg-3 col-xs-3 col-md-3 col-sm-3">
                                    <button class="btn btn-outline-light btn-sm" (click)="onSave()">Save</button>
                                </div>
                                <div class="col-lg-3 col-xs-3 col-md-3 col-sm-3">
                                    <button class="btn btn-outline-light btn-sm" (click)="goBack()">Go back</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="" *ngIf="!isUserLogin">
    <app-slider></app-slider>
    <div class="loading">
        <div class="wrapper padding-top-30">
            <div class="container">
                <p>Oops, The page you are looking for can't be found!</p>
                <div class="missing-page">
                    <span class="side">4</span>
                    <span class="taiji-icon"></span>
                    <span class="side">4</span>
                </div>
                <p>Loading...</p>
            </div>
        </div>
    </div>
    <div class="socail-media padding-top-30">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                    <instagram-post></instagram-post>
                </div>
                <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                    <tumblr-posts></tumblr-posts>
                </div>
            </div>
        </div>
    </div>
</div>
